"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_switch_1 = tslib_1.__importDefault(require("rc-switch"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var defs_1 = require("../Form/defs");
var icons_1 = require("../icons");
var hooks_1 = require("../utils/hooks");
function Switch(props) {
    var rootHtmlProps = props.rootHtmlProps, className = props.className, size = props.size, onChange = props.onChange, style = props.style, _a = props.loading, loading = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, rest = tslib_1.__rest(props, ["rootHtmlProps", "className", "size", "onChange", "style", "loading", "disabled"]);
    var prefix = ConfigProvider_1.usePrefix('switch');
    var formSize = defs_1.useFormSize(size);
    var sizeCls = utils_1.concat(prefix, formSize);
    var spinCls = hooks_1.useAnimationCls().spinCls;
    function renderHandle() {
        if (loading) {
            return (react_1.default.createElement("div", { className: classnames_1.default(utils_1.concat(prefix, 'handle'), utils_1.concat(prefix, 'handle', 'loading'), spinCls) },
                react_1.default.createElement(icons_1.LoadingThinIcon, null)));
        }
        return react_1.default.createElement("div", { className: utils_1.concat(prefix, 'handle') });
    }
    function handleChange(nextChecked, event) {
        var _a;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onChange) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, event);
        if (event.defaultPrevented)
            return;
        onChange === null || onChange === void 0 ? void 0 : onChange(nextChecked);
    }
    return (react_1.default.createElement(rc_switch_1.default, tslib_1.__assign({ prefixCls: prefix, loadingIcon: renderHandle() }, rootHtmlProps, { 
        // 此 as 解决 rc-switch 会给 keyboard event 的问题，button 无法触发键盘事件
        onChange: (onChange || (rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onChange)) && handleChange, className: classnames_1.default(className, sizeCls, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className), style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style), disabled: disabled || loading }, rest)));
}
exports.Switch = Switch;
//# sourceMappingURL=index.js.map